module.exports = __webpack_public_path__ + "static/img/BIO.03abf28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BIO.png
// module id = fU2P
// module chunks = 1